<style scoped lang="scss">

</style>
<template>
    <div class="message is-danger" v-if="hasErrors">
        <div class="message-body">
            <ul>
                <li v-for="error of allErrors">{{ error }}</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props : {
        errors : Object
    },
    computed : {
        hasErrors() {
            return !! Object
                .keys( this.errors )
                .reduce( (result, key) => result + this.errors[key].length, 0 )
            ;
        },
        allErrors() {
            return Object
                .keys( this.errors )
                .reduce( (result, key) => result.concat(this.errors[key]), [] )
            ;
        }
    }
}
</script>
